module.exports = __webpack_public_path__ + "img/grid.95e18ce0.svg";